// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_consoleContainer__42LnA {
  width: 100%;
  min-height: 100vh;
  padding: 24px;
  box-sizing: border-box;
}

.styles_container__SCRxz {
  max-width: 800px;
  margin: 0 auto;
}

.styles_header__kr26u {
  position: relative;
  text-align: center;
  margin-bottom: 24px;
}

.styles_toggleContainer__\\+zp4P {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
@media (max-width: 768px) {
  .styles_toggleContainer__\\+zp4P {
    position: static;
    justify-content: center;
    padding-top: 12px;
    margin-top: 12px;
  }
}

.styles_toggleLabel__K7V4Y {
  font-size: 14px;
  color: #6b7280;
}

.styles_toggle__2HaN2 {
  position: relative;
  width: 48px;
  height: 24px;
  background: #d1d5db;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s;
  padding: 0;
}
.styles_toggle__2HaN2.styles_enabled__Dxj1x {
  background: #22c55e;
}

.styles_toggleSlider__LzbGn {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  transition: transform 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.styles_enabled__Dxj1x .styles_toggleSlider__LzbGn {
  transform: translateX(24px);
}

.styles_noCourses__Qnq3z {
  text-align: center;
  padding: 48px 24px;
  color: #6b7280;
}

.styles_error__vFTab {
  text-align: center;
  padding: 24px;
  color: #ef4444;
}

.styles_coursesList__vPV3p {
  background: white;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}
.styles_coursesList__vPV3p.styles_disabled__zwzjl {
  opacity: 0.5;
  pointer-events: none;
}

.styles_listHeader__3JI2F {
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.styles_headerLabel__lo2G5 {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.styles_courseRow__kxLXO {
  border-bottom: 1px solid #e5e7eb;
}
.styles_courseRow__kxLXO:last-child {
  border-bottom: none;
}

.styles_courseMain__7M0-v {
  display: flex;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  transition: background 0.15s;
}
.styles_courseMain__7M0-v:hover {
  background: #f9fafb;
}

.styles_courseInfo__GhKI\\+ {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.styles_colorDot__cNU-b {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.styles_courseName__1qKXp {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.styles_sliderContainer__ylC9f {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  max-width: 200px;
}

.styles_slider__cPTKn {
  flex: 1 1;
  height: 6px;
  appearance: none;
  background: linear-gradient(to right, var(--slider-color) 0%, var(--slider-color) var(--slider-percent), #e5e7eb var(--slider-percent), #e5e7eb 100%);
  border-radius: 3px;
  cursor: pointer;
}
.styles_slider__cPTKn::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  background: white;
  border: 2px solid var(--slider-color);
  border-radius: 50%;
  cursor: pointer;
  -webkit-transition: transform 0.1s;
  transition: transform 0.1s;
}
.styles_slider__cPTKn::-webkit-slider-thumb:hover {
  transform: scale(1.1);
}
.styles_slider__cPTKn::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: white;
  border: 2px solid var(--slider-color);
  border-radius: 50%;
  cursor: pointer;
}
.styles_slider__cPTKn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.styles_hoursValue__NC941 {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  min-width: 36px;
  text-align: right;
}

.styles_expandIcon__T8goo {
  font-size: 12px;
  color: #9ca3af;
  margin-left: 8px;
  transition: transform 0.2s;
}
.styles_expandIcon__T8goo.styles_expanded__dAz0P {
  transform: rotate(180deg);
}

.styles_breakdown__NlCxi {
  padding: 0 16px 16px 40px;
  background: #f9fafb;
}

.styles_breakdownHeader__Um92P {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.styles_breakdownRow__zj52J {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.styles_breakdownLabel__AiY8W {
  font-size: 13px;
  color: #4b5563;
  width: 100px;
  flex-shrink: 0;
}

@media (max-width: 640px) {
  .styles_consoleContainer__42LnA {
    padding: 16px;
  }
  .styles_header__kr26u {
    flex-direction: column;
    gap: 16px;
  }
  .styles_toggleContainer__\\+zp4P {
    padding-top: 0;
  }
  .styles_courseMain__7M0-v {
    flex-wrap: wrap;
    gap: 12px;
    position: relative;
  }
  .styles_courseInfo__GhKI\\+ {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(100% - 24px);
  }
  .styles_sliderContainer__ylC9f {
    flex: 1 1 100%;
    max-width: none;
  }
  .styles_expandIcon__T8goo {
    position: absolute;
    top: 16px;
    right: 16px;
    margin-left: 0;
  }
  .styles_breakdown__NlCxi {
    padding-left: 16px;
  }
  .styles_actionButtons__DTWeN {
    flex-direction: column;
    gap: 12px;
  }
  .styles_undoButton__onsd3,
  .styles_saveButton__c6\\+Ht {
    width: 100%;
  }
}
.styles_actionButtons__DTWeN {
  display: flex;
  gap: 16px;
  margin-top: 24px;
  width: 100%;
  animation: styles_slideIn__yKGBC 0.3s ease-out;
}

@keyframes styles_slideIn__yKGBC {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.styles_undoButton__onsd3 {
  flex: 1 1;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1a;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.styles_undoButton__onsd3:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #d1d5db;
}
.styles_undoButton__onsd3:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.styles_saveButton__c6\\+Ht {
  flex: 1 1;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 500;
  color: white;
  background: #2563eb;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s ease;
}
.styles_saveButton__c6\\+Ht:hover:not(:disabled) {
  background: #1d4ed8;
}
.styles_saveButton__c6\\+Ht:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/screens/console/styles.module.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EARF;IASI,gBAAA;IACA,uBAAA;IACA,iBAAA;IACA,gBAAA;EACF;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,UAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,wCAAA;AAAF;AAEE;EACE,2BAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AADF;AAGE;EACE,YAAA;EACA,oBAAA;AADJ;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;AAIE;EACE,mBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,4BAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;AAJF;;AAOA;EACE,SAAA;EACA,WAAA;EAEA,gBAAA;EACA,qJAAA;EAOA,kBAAA;EACA,eAAA;AAVF;AAYE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EAAA,0BAAA;AAVJ;AAYI;EACE,qBAAA;AAVN;AAcE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;AAZJ;AAeE;EACE,mBAAA;EACA,YAAA;AAbJ;;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;AAdF;AAgBE;EACE,yBAAA;AAdJ;;AAkBA;EACE,yBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AAfF;;AAkBA;EACE;IACE,aAAA;EAfF;EAkBA;IACE,sBAAA;IACA,SAAA;EAhBF;EAmBA;IACE,cAAA;EAjBF;EAoBA;IACE,eAAA;IACA,SAAA;IACA,kBAAA;EAlBF;EAqBA;IACE,YAAA;IAAA,cAAA;IAAA,6BAAA;EAnBF;EAsBA;IACE,cAAA;IACA,eAAA;EApBF;EAuBA;IACE,kBAAA;IACA,SAAA;IACA,WAAA;IACA,cAAA;EArBF;EAwBA;IACE,kBAAA;EAtBF;EAyBA;IACE,sBAAA;IACA,SAAA;EAvBF;EA0BA;;IAEE,WAAA;EAxBF;AACF;AA4BA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EAGA,8CAAA;AA5BF;;AA+BA;EACE;IACE,UAAA;IACA,2BAAA;EA5BF;EA8BA;IACE,UAAA;IACA,wBAAA;EA5BF;AACF;AA+BA;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AA7BF;AA+BE;EACE,mBAAA;EACA,qBAAA;AA7BJ;AAgCE;EACE,YAAA;EACA,mBAAA;AA9BJ;;AAkCA;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AA/BF;AAiCE;EACE,mBAAA;AA/BJ;AAkCE;EACE,YAAA;EACA,mBAAA;AAhCJ","sourcesContent":["@import \"mixins\";\n.consoleContainer {\n  width: 100%;\n  min-height: 100vh;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.container {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.header {\n  position: relative;\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.toggleContainer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  @media (max-width: 768px) {\n    position: static;\n    justify-content: center;\n    padding-top: 12px;\n    margin-top: 12px;\n  }\n}\n\n.toggleLabel {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.toggle {\n  position: relative;\n  width: 48px;\n  height: 24px;\n  background: #d1d5db;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background 0.2s;\n  padding: 0;\n\n  &.enabled {\n    background: #22c55e;\n  }\n}\n\n.toggleSlider {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background: white;\n  border-radius: 50%;\n  transition: transform 0.2s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n\n  .enabled & {\n    transform: translateX(24px);\n  }\n}\n\n.noCourses {\n  text-align: center;\n  padding: 48px 24px;\n  color: #6b7280;\n}\n\n.error {\n  text-align: center;\n  padding: 24px;\n  color: #ef4444;\n}\n\n.coursesList {\n  background: white;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n\n  &.disabled {\n    opacity: 0.5;\n    pointer-events: none;\n  }\n}\n\n.listHeader {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.headerLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.courseRow {\n  border-bottom: 1px solid #e5e7eb;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.courseMain {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  cursor: pointer;\n  transition: background 0.15s;\n\n  &:hover {\n    background: #f9fafb;\n  }\n}\n\n.courseInfo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.colorDot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.courseName {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1f2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sliderContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  max-width: 200px;\n}\n\n.slider {\n  flex: 1;\n  height: 6px;\n  -webkit-appearance: none;\n  appearance: none;\n  background: linear-gradient(\n    to right,\n    var(--slider-color) 0%,\n    var(--slider-color) var(--slider-percent),\n    #e5e7eb var(--slider-percent),\n    #e5e7eb 100%\n  );\n  border-radius: 3px;\n  cursor: pointer;\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 16px;\n    height: 16px;\n    background: white;\n    border: 2px solid var(--slider-color);\n    border-radius: 50%;\n    cursor: pointer;\n    transition: transform 0.1s;\n\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n\n  &::-moz-range-thumb {\n    width: 16px;\n    height: 16px;\n    background: white;\n    border: 2px solid var(--slider-color);\n    border-radius: 50%;\n    cursor: pointer;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n}\n\n.hoursValue {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1f2937;\n  min-width: 36px;\n  text-align: right;\n}\n\n.expandIcon {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-left: 8px;\n  transition: transform 0.2s;\n\n  &.expanded {\n    transform: rotate(180deg);\n  }\n}\n\n.breakdown {\n  padding: 0 16px 16px 40px;\n  background: #f9fafb;\n}\n\n.breakdownHeader {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.breakdownRow {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n}\n\n.breakdownLabel {\n  font-size: 13px;\n  color: #4b5563;\n  width: 100px;\n  flex-shrink: 0;\n}\n\n@media (max-width: 640px) {\n  .consoleContainer {\n    padding: 16px;\n  }\n\n  .header {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .toggleContainer {\n    padding-top: 0;\n  }\n\n  .courseMain {\n    flex-wrap: wrap;\n    gap: 12px;\n    position: relative;\n  }\n\n  .courseInfo {\n    flex: 1 1 calc(100% - 24px); // Leave room for expand icon\n  }\n\n  .sliderContainer {\n    flex: 1 1 100%;\n    max-width: none;\n  }\n\n  .expandIcon {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    margin-left: 0;\n  }\n\n  .breakdown {\n    padding-left: 16px;\n  }\n\n  .actionButtons {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .undoButton,\n  .saveButton {\n    width: 100%;\n  }\n}\n\n// Action buttons with slide-in animation\n.actionButtons {\n  display: flex;\n  gap: 16px;\n  margin-top: 24px;\n  width: 100%;\n\n  // Slide-in animation\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.undoButton {\n  flex: 1;\n  padding: 14px 24px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #1a1a1a;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover:not(:disabled) {\n    background: #f9fafb;\n    border-color: #d1d5db;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.saveButton {\n  flex: 1;\n  padding: 14px 24px;\n  font-size: 16px;\n  font-weight: 500;\n  color: white;\n  background: #2563eb;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n\n  &:hover:not(:disabled) {\n    background: #1d4ed8;\n  }\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"consoleContainer": `styles_consoleContainer__42LnA`,
	"container": `styles_container__SCRxz`,
	"header": `styles_header__kr26u`,
	"toggleContainer": `styles_toggleContainer__+zp4P`,
	"toggleLabel": `styles_toggleLabel__K7V4Y`,
	"toggle": `styles_toggle__2HaN2`,
	"enabled": `styles_enabled__Dxj1x`,
	"toggleSlider": `styles_toggleSlider__LzbGn`,
	"noCourses": `styles_noCourses__Qnq3z`,
	"error": `styles_error__vFTab`,
	"coursesList": `styles_coursesList__vPV3p`,
	"disabled": `styles_disabled__zwzjl`,
	"listHeader": `styles_listHeader__3JI2F`,
	"headerLabel": `styles_headerLabel__lo2G5`,
	"courseRow": `styles_courseRow__kxLXO`,
	"courseMain": `styles_courseMain__7M0-v`,
	"courseInfo": `styles_courseInfo__GhKI+`,
	"colorDot": `styles_colorDot__cNU-b`,
	"courseName": `styles_courseName__1qKXp`,
	"sliderContainer": `styles_sliderContainer__ylC9f`,
	"slider": `styles_slider__cPTKn`,
	"hoursValue": `styles_hoursValue__NC941`,
	"expandIcon": `styles_expandIcon__T8goo`,
	"expanded": `styles_expanded__dAz0P`,
	"breakdown": `styles_breakdown__NlCxi`,
	"breakdownHeader": `styles_breakdownHeader__Um92P`,
	"breakdownRow": `styles_breakdownRow__zj52J`,
	"breakdownLabel": `styles_breakdownLabel__AiY8W`,
	"actionButtons": `styles_actionButtons__DTWeN`,
	"undoButton": `styles_undoButton__onsd3`,
	"saveButton": `styles_saveButton__c6+Ht`,
	"slideIn": `styles_slideIn__yKGBC`
};
export default ___CSS_LOADER_EXPORT___;
